const businessSlugs: Record<string, string> = {
  "api-g-apiarios-gil": "api-g",
};

const businessIdsBySlug = Object.fromEntries(
  Object.entries(businessSlugs).map(([id, slug]) => [slug, id])
);

export const getBusinessSlug = (businessId: string) =>
  businessSlugs[businessId] ?? businessId;

export const resolveBusinessId = (slug: string) =>
  businessIdsBySlug[slug] ?? slug;

export const getBusinessPath = (businessId: string, section = "") => {
  const base = `/${getBusinessSlug(businessId)}`;
  return section ? `${base}/${section}` : base;
};
